import React, { useState } from 'react';
import { FaFilePdf, FaSearch } from 'react-icons/fa';
import demo3 from '../assets/documents/ParkingTariff.pdf';
import demo4 from '../assets/documents/PreparationofPanel.pdf';
import demo2 from '../assets/documents/RestaurantTariff.pdf';
import demo1 from '../assets/documents/TenderNotice.pdf';
import { useSelector } from 'react-redux';
import { convertToMarathiNumber } from '../components/marathiNumbers';
import { Link } from 'react-router-dom';

const Tenders = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const selectedLang = useSelector((state) => state.language.selectedLang);

    const content = {
        English: {
            title: "Tenders",
            searchPlaceholder: "Search For Monuments, Museum Or District",
            breadcrumb: {
                home: "HOME",
                page: "TENDERS",
            },
            noResult: "No results found.",
        },
        मराठी: {
            title: "निविदा",
            searchPlaceholder: "स्मारके, संग्रहालय किंवा जिल्हा शोधा",
            breadcrumb: {
                home: "मुख्यपृष्ठ ",
                page: "निविदा",
            },
            noResult: "परिणाम सापडले नाहीत.",
        },
    };
    const t = content[selectedLang];

    const tabLabels = {
        current: {
            English: "Current Tenders",
            मराठी: "सध्याच्या निविदा",
        },
        archives: {
            English: "Archives",
            मराठी: "संग्रहण",
        },
    };

    const tableHeaders = {
        srNo: {
            English: "Sr. No.",
            मराठी: "अ.क्र.",
        },
        division: {
            English: "Division / District",
            मराठी: "विभाग / जिल्हा",
        },
        tenders: {
            English: "Tenders",
            मराठी: "निविदा",
        },
        publishdate: {
            English: "Publish Date",
            मराठी: "प्रकाशन तारीख",
        },
        lastdate: {
            English: `Last Date`,
            मराठी: `शेवटची तारीख`,
        },
        downloads: {
            English: `Downloads`,
            मराठी: `डाउनलोड`,
        }
    };

    const commonTenders = [
        {
            id: 'tender-1',
            title: {
                English: "Tender Notice Directorate of Archaeology Museums",
                मराठी: "निविदा सूचना – पुरातत्व व संग्रहालय संचालनालय",
            },
            division: {
                English: "Ratnagiri/Palghar",
                मराठी: "रत्नागिरी/पालघर",
            },
            file: demo1,
        },
        {
            id: 'tender-2',
            title: {
                English: "Restaurant Tariff Notice, Terms and Conditions",
                मराठी: "उपहारगृह दरपत्रक सूचना, अटी व शर्ती",
            },
            division: {
                English: "Pune/Satara",
                मराठी: "पुणे/सातारा",
            },
            file: demo2,
        },
        {
            id: 'tender-3',
            title: {
                English: "Parking Tariff Notice, Terms and Conditions",
                मराठी: "वाहनतळ दरपत्रक सूचना, अटी व शर्ती",
            },
            division: {
                English: "Nagpur/Chandrapur",
                मराठी: "नागपूर/चंद्रपूर",
            },
            file: demo3,
        },
        {
            id: 'tender-4',
            title: {
                English: "Preparation of Panel for Group-B Officers on Deputation",
                मराठी: "वाहनतळ दरपत्रक सूचना, अटी व शर्ती",
            },
            division: {
                English: "Nagpur/Chandrapur",
                मराठी: "नागपूर/चंद्रपूर",
            },
            file: demo4,
        },
    ];


    const currentDates = [
        {
            publishDate: {
                English: "10-07-2025",
                मराठी: "१०-०७-२०२५",
            },
            lastDate: {
                English: "10-09-2025",
                मराठी: "१०-०९-२०२५",
            },
        },
        {
            publishDate: {
                English: "06-08-2025",
                मराठी: "०६-०८-२०२५",
            },
            lastDate: {
                English: "06-10-2025",
                मराठी: "०६-१०-२०२५",
            },
        },
        {
            publishDate: {
                English: "05-06-2025",
                मराठी: "०५-०६-२०२५",
            },
            lastDate: {
                English: "05-09-2025",
                मराठी: "०५-०९-२०२५",
            },
        },
        {
            publishDate: {
                English: "10-07-2025",
                मराठी: "१०-०७-२०२५",
            },
            lastDate: {
                English: "20-07-2025",
                मराठी: "२०-०७-२०२५",
            },
        },
    ];

    const archiveDates = [
        {
            publishDate: {
                English: "10-06-2025",
                मराठी: "१०-०६-२०२५",
            },
            lastDate: {
                English: "10-08-2025",
                मराठी: "१०-०८-२०२५",
            },
        },
        {
            publishDate: {
                English: "06-06-2025",
                मराठी: "०६-०६-२०२५",
            },
            lastDate: {
                English: "06-09-2025",
                मराठी: "०६-०९-२०२५",
            },
        },
        {
            publishDate: {
                English: "05-06-2025",
                मराठी: "०५-०६-२०२५",
            },
            lastDate: {
                English: "05-09-2025",
                मराठी: "०५-०९-२०२५",
            },
        },
         {
            publishDate: {
                English: "05-06-2025",
                मराठी: "०५-०६-२०२५",
            },
            lastDate: {
                English: "15-06-2025",
                मराठी: "१५-०६-२०२५",
            },
        },
    ];

    const [isCurrent, setIsCurrent] = useState(true);
    const datesToShow = isCurrent ? currentDates : archiveDates;
    const isArchiveActive = !isCurrent;

    const combinedTenders = commonTenders.map((item, index) => ({
        ...item,
        publishDate: datesToShow[index].publishDate,
        lastDate: datesToShow[index].lastDate,
    }));

    const filteredTenders = combinedTenders.filter((item) => {
        const divisionMatch = item.division[selectedLang].toLowerCase().includes(searchTerm.toLowerCase());
        const titleMatch = item.title[selectedLang].toLowerCase().includes(searchTerm.toLowerCase());
        return divisionMatch || titleMatch;
    });

    return (
        <div className="min-h-screen px-4 py-12">
            {/* Title */}
            <div className="text-center mb-8">
                <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
                    {t.title}
                </h1>
                <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
                    <span style={{ color: "#DD9827" }}>
                        <Link to="/" className="hover:underline">
                            {t.breadcrumb.home}
                        </Link>{" "}/{" "}</span>
                    {t.breadcrumb.page}
                </p>
            </div>

            {/* Toggle Buttons */}
            <div className="flex justify-center gap-4 mb-10 no-dark-bg">
                <button
                    onClick={() => setIsCurrent(true)}
                    className={`tab-button px-4 py-2 font-futura border border-orange-500 rounded-md transition duration-300 ${isCurrent
                        ? 'active-tab'
                        : 'hover:bg-[#DD9827] hover:text-white border-[#DD9827]'
                        }`}
                >
                    {tabLabels.current[selectedLang]}
                </button>
                <button
                    onClick={() => setIsCurrent(false)}
                    className={`tab-button px-4 py-2 font-futura border border-orange-500 rounded-md transition duration-300 ${isArchiveActive
                        ? 'active-tab'
                        : 'hover:bg-[#DD9827] hover:text-white border-[#DD9827]'
                        }`}
                >
                    {tabLabels.archives[selectedLang]}
                </button>
            </div>

            {/* Table */}
            {/* Table + Search Container */}
            <div className="max-w-6xl mx-auto overflow-x-auto">
                {/* Search Input Top-Right */}
                <div className="max-w-5xl mx-auto">
                    <div className="flex justify-end mt-4">
                        <div className="relative w-full sm:w-80">
                            {/* Search Icon */}
                            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />

                            {/* Separator Line */}
                            <span className="absolute left-9 top-1/2 transform -translate-y-1/2 text-gray-300">|</span>

                            {/* Input */}
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder={t.searchPlaceholder}
                                className="w-full pl-12 pr-4 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-400 placeholder:text-[12px]  bg-[#EFEDE0]"
                            />
                        </div>
                    </div>
                    <div
                        className="overflow-hidden  mt-4 no-dark-bg"
                        style={{ borderColor: '#F8D6BF' }}
                    >
                        <div className="overflow-x-auto bg-[#EFEDE0] rounded-xl" style={{ border: "2px solid #F8D6BF" }}>
                            <table className="min-w-full text-center text-black text-sm sm:text-base">
                                <thead className='font-bold tracking-wide' style={{
                                    textShadow: '0.3px 0.3px 0 black',
                                }}>
                                    <tr>
                                        <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                            {tableHeaders.srNo[selectedLang]}
                                        </th>
                                        <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                            {tableHeaders.tenders[selectedLang]}
                                        </th>
                                        <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                            {tableHeaders.division[selectedLang]}
                                        </th>
                                        <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                            {tableHeaders.publishdate[selectedLang]}
                                        </th>
                                        <th className="py-3 px-4 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                            {tableHeaders.lastdate[selectedLang]}
                                        </th>
                                        <th className="py-3 px-4" style={{ borderColor: '#F8D6BF' }}>
                                            {tableHeaders.downloads[selectedLang]}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredTenders.length > 0 ? (
                                        filteredTenders.map((item, index) => (
                                            <tr key={item.id} className="hover:bg-[#F6F6EC]">
                                                <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                    {selectedLang === 'मराठी' ? convertToMarathiNumber(index + 1) : `${index + 1}`}.
                                                </td>
                                                <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                    {item.title[selectedLang]}
                                                </td>
                                                <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                    {item.division[selectedLang]}
                                                </td>
                                                <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                    {item.publishDate[selectedLang]}
                                                </td>
                                                <td className="py-3 px-4 border-t-2 border-r-2" style={{ borderColor: '#F8D6BF' }}>
                                                    {item.lastDate[selectedLang]}
                                                </td>
                                                <td className="py-3 px-4 border-t-2" style={{ borderColor: '#F8D6BF' }}>
                                                    <a
                                                        href={item.file}
                                                        download
                                                        title="Download PDF"
                                                        className="text-red-600 hover:text-red-800 flex justify-center"
                                                    >
                                                        <FaFilePdf size={20} />
                                                    </a>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center py-6 text-gray-500">
                                                {t.noResult}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tenders;
